import { useEffect, useState } from "react";
import { getIsAuthed, getIsInitialized, subscribe } from "./authStore";

export function useAuth() {
  const [isAuthed, setIsAuthedState] = useState(getIsAuthed());
  const [initialized, setInitializedState] = useState(getIsInitialized());

  useEffect(() => {
    return subscribe(() => {
      setIsAuthedState(getIsAuthed());
      setInitializedState(getIsInitialized());
    });
  }, []);

  return { isAuthed, initialized };
}
